import styled from '@emotion/styled';
import { RadioGroup } from '@material-ui/core';

const HorizontalRadioGroup = styled(RadioGroup)({
  flexDirection: 'row',
});

export default HorizontalRadioGroup;
